import * as THREE from 'three';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';

const loadImages = async (images, itemsDimensions) => {

    // const images = [
    //     { img: img1, link: 'https://www.google.it', text: 'Img 1' },
    // ];

    const loaded = [];
    const fontLoader = new FontLoader();
    const font = await new Promise((resolve, reject) => {
        fontLoader.load('../fonts/TT-Forma-new.json', resolve, undefined, reject);
    });

    for (let i = 0; i < images.length; i++) {
        const img = new Image();
        img.src = images[i].img;
        await img.decode(); // Wait for the image to load

        const aspectRatio = (img.width / img.height).toFixed(2);

        const maxWidth = itemsDimensions[0];
        const maxHeight = itemsDimensions[1];
        
        let geometryWidth, geometryHeight;
        if (aspectRatio > 1) {
        // Landscape orientation
        geometryWidth = maxWidth;
        geometryHeight = maxWidth / aspectRatio;
        } else {
        // Portrait orientation
        geometryHeight = maxHeight;
        geometryWidth = maxHeight * aspectRatio;
        }

        // console.log(`${images[i].title} - ${img.width}x${img.height}, AR:${aspectRatio}, G:${geometryWidth}x${geometryHeight}, D:${itemsDimensions[0]}x${itemsDimensions[1]}`);

        const geometry = new THREE.PlaneGeometry(geometryWidth, geometryHeight);
        geometry.scale(0.5, 0.5, 0.5);

        const texture = new THREE.TextureLoader().load(images[i].img, (texture) => {
            texture.colorSpace = THREE.SRGBColorSpace;
            //texture.flipY = false; // Flip the texture on the Y-axis
        });

        const material = new THREE.MeshBasicMaterial({ map: texture });
        //material.side = THREE.BackSide;
        
        const titleMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff });
        const titleGeometry = new TextGeometry(images[i].title, {
            font: font,
            size: 0.18,
            depth: 0,
            curveSegments: 10,
        });

        const textMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff });
        const textGeometry = new TextGeometry(images[i].text, {
            font: font,
            size: 0.14,
            depth: 0,
            curveSegments: 10,
        });
        
        loaded.push({
            geometry, material,
            titleGeometry, titleMaterial,
            textGeometry, textMaterial,
            title: images[i].title,
            text: images[i].text,
            image: images[i].img,
            link: images[i].link
        });
    }

    return { count: images.length, images: loaded };
};

export default loadImages;
